export const SPACESHIP =  `
                      . ___                                  
                    __,' __'.                _..----....____ 
        __...--.''';.   ,.   ;''--..__     .'    ,-._    _.-'
  _..-''-------'   ''   ''   ''     O ''-''._   (,;') _,'    
,'________________                          /'-._'-','       
 '._              ''''''''''------...___   '-.._'-:          
    '''--.._      ,.                     ''''--...__/-.      
            '.--. '-'    CODING SPACE       ____    |  |',   
              '. '.                       ,''''''.  ;  ;'.   
                '._'.        __________   '.      \\'__/'''   
                   '-:._____/______/___/____'.     \\  '      
                               |       '._    '.    \\        
                               '._________'-.   '.   '.___   
                                                  '------''  `

export const COMPUTER = `
             ________________________________________________
            /                                                \\
           |    _________________________________________     |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |              CODING SPACE               |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |                                         |    |
           |   |_________________________________________|    |
           |                                                  |
            \\_________________________________________________/
                   \\___________________________________/
                ___________________________________________
             _-'    .-.-.-.-.-.-.-.-.-.-.-.-.-.-.-.-.  --- \`-_
          _-'.-.-. .---.-.-.-.-.-.-.-.-.-.-.-.-.-.-.--.  .-.-.\`-_
       _-'.-.-.-. .---.-.-.-.-.-.-.-.-.-.-.-.-.-.-.-\`__\`. .-.-.-.\`-_
    _-'.-.-.-.-. .-----.-.-.-.-.-.-.-.-.-.-.-.-.-.-.-----. .-.-.-.-.\`-_
 _-'.-.-.-.-.-. .---.-. .-------------------------. .-.---. .---.-.-.-.\`-_
:-------------------------------------------------------------------------:
\`---._.-------------------------------------------------------------._.---'
`
export const SATURN =`

                .                                            .                  
     *   .                  .              .        .   *          .            
  .         .                     .       .           .      .        .         
        o                             .                   .                     
         .              .                  .           .                        
          0     .                                                               
                 .          .      CODING SPACE  ,                ,    ,        
 .          \\          .                         .                             
      .      \\   ,                                                             
   .          o     .                 .                   .            .        
     .         \\                 ,             .                .              
               #\\##\\#      .                              .        .          
             #  #O##\\###                .                        .             
   .        #*#  #\\##\\###                       .                     ,       
        .   ##*#  #\\##\\##               .                     .               
      .      ##*#  #o##\\#         .                             ,       .      
          .     *#  #\\#     .                    .             .          ,    
                      \\          .                         .                   
____^/\\___^--____/\\____O______________/\\/\\---/\\___________---______________
   /\\^   ^  ^    ^                  ^^ ^  '\\ ^          ^       ---           
         --           -            --  -      -         ---  __       ^         
   --  __                      ___--  ^  ^                         --  __       

   `